import { createContext, FC, useEffect } from "react";
import * as socketClient from "socket.io-client";
import { useUser } from "../hooks/useUser";

const URL_SOCKET = process.env.REACT_APP_URL_SOCKET || "https://wschat.amplimed.com.br";

const socket = socketClient.connect(URL_SOCKET, {
  extraHeaders: {
    Authorization:
      localStorage.getItem("token") ||
      new URLSearchParams(window.location.search).get("token") ||
      "",
  },
});

const SocketContext = createContext(socket);

const SocketContextProvider: FC = ({ children }) => {
  const { user } = useUser();

  // Remove os listeners do socket quando o chat é desmontado
  useEffect(() => {
    return () => {
      socket.off();
    };
  }, []);

  // Realiza login
  useEffect(() => {
    socket.emit("login", user);

    socket.on("connect", () => {
      console.log("Usuario reconectado");
      socket.emit("login", user);
    });
  }, [user]);

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export { SocketContextProvider, SocketContext };
